export default __webpack_public_path__ + "static/media/Control_tower.ea104a05.png";